<template>
    <div>
        <div v-if="preloader">
            <progress :max="100" :value.sync="progressPer" style="width: 100%;" />
            <div class="parser_info_container">
                <div v-if="listLength" class="parser_info_box">
                    <span data-title>Всего организаций</span>
                    <span v-html="listLength" />
                </div>
                <div v-if="listNotCat && listNotCat.length" class="parser_info_box">
                    <span data-title>Без категорий <button class="btn_download" @click="saveResult(listNotCat)">(Скачать)</button></span>
                    <span v-html="listNotCat.length" />
                </div>
                <div v-if="listLength && listNotCat && listNotCat.length" class="parser_info_box">
                    <span data-title>С категориями</span>
                    <span v-html="listLength - listNotCat.length" />
                </div>
                <div v-if="excelArray && excelArray.length && (success_array && success_array.length || error_array && error_array.length)" class="parser_info_box">
                    <span data-title>Осталось</span>
                    <span v-html="excelArray.length - success_array.length - error_array.length" />
                </div>
            </div>
            <div v-if="list && list.length" class="default_box table-responsive">
                <div v-if="parserStatus">
                    <input id="xlf" type="file" name="xlfile" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" @change="displayFile($event)">
                    <button v-if="excelArray && excelArray.length" class="btn_primary" @click="startPars">
                        Запустить парсер
                    </button>
                </div>
                <Preloader v-else />
            </div>
            <div v-else class="default_box">
                Не удалось загрузить категории справочника. Возможно они не созданы.
            </div>
            <b-row>
                <b-col v-if="success_array && success_array.length" lg="6">
                    <infoBlock status="success" :list="success_array" />
                </b-col>
                <b-col v-if="error_array && error_array.length" lg="6">
                    <infoBlock status="danger" :list="error_array" />
                </b-col>
            </b-row>
        </div>
        <Preloader v-else />
    </div>
</template>
<script>
import infoBlock from "./components/infoBlock";
import XLSX from "xlsx";
import { saveAs } from "file-saver";
export default {
    name: "ParserIndex",
    components: {
        infoBlock
    },
    data() {
        return {
            city: "solnechnyj",
            preloader: true,
            parserStatus: true,
            excelArray: null,
            listLength: null,
            listNotCat: null,
            list: null,
            progressPer: 0,
            not: [],
            success_array: [],
            error_array: []
        }
    },
    computed: {
        progress: {
            get() {
                return this.progressPer
            },
            set(val) {
                this.progressPer = Math.floor(100 / val)
            }
        }
    },
    mounted() {
        this.api();
    },
    methods: {
        async asyncForEach(array, callback) {
            for (let index = 0; index < array.length; index++) {
                let aWait = (x) => new Promise((resolve) => setTimeout(resolve, x));

                await callback(array[index], index, array);
                await aWait(1500);
            }
        },
        displayFile(e) {
            if (e && e.target && e.target.files && e.target.files.length) {
                var files = e.target.files,
                    f = files[0];
                var reader = new FileReader();
                reader.onload = function(e) {
                    var data = new Uint8Array(e.target.result);
                    var workbook = XLSX.read(data, { type: "array" });
                    let sheetName = workbook.SheetNames[0];
                    let worksheet = workbook.Sheets[sheetName];
                    this.changeCategory(XLSX.utils.sheet_to_json(worksheet))
                }.bind(this);
                reader.readAsArrayBuffer(f);
            }

        },
        async changeCategory(array) {
            if (this.list && this.list.length) {
                this.listLength = array.length;
                let data = [];
                data = await array.map(elem => {
                    elem.category = elem.category.split("|").map(item => {
                        return item.trim().toLowerCase();
                    });

                    elem.category = elem.category.map(item => {
                        let item2 = this.list.find(o => o.yandex == item.toLowerCase() || o.rubricator == item.toLowerCase());
                        if (item2 && item2.id) {
                            return item2.id;
                        }
                    }).filter(notUndefined => notUndefined !== undefined);

                    if (elem.shedule) {
                        elem.shedule_old = elem.shedule;
                    }

                    return elem;
                })

                this.excelArray = data.filter(e => e.category.length > 0);
                this.listNotCat = data.filter(notUndefined => notUndefined.category.length === 0);
            } else {
                this.$toast.error("Не удалось загрузить категории справочника по API. Перезагрузите страницу");
            }
        },
        async startPars() {
            this.parserStatus = false;

            this.asyncForEach(this.excelArray, async (item) => {
                if (item.category) {
                    await this.send(item);
                }
            }).finally(() => {
                this.parserStatus = true;
            })

        },
        send(array) {
            let address = [];
            if (array.address) {
                let data = {
                    "address": array.address + (array.address_description ? ", " + array.address_description : ""),
                    "latitude": array.latitude ? array.latitude : this.$city.x,
                    "longitude": array.longitude ? array.longitude : this.$city.y,
                    "times": []
                }

                array.shedule_old ? data['working_days'] = array.shedule_old : '';
                address.push(data);
            } else {
                let data = {
                    "address": this.$city.name,
                    "latitude": this.$city.x,
                    "longitude": this.$city.y,
                    "times": []
                }

                array.shedule_old ? data['working_days'] = array.shedule_old : '';
                address.push(data);
            }
            let sites = []
            if (array.site && array.site.trim().length) {
                let site_item = {
                    "url": array.site.trim()
                }
                sites.push(site_item);
            }
            if (array.Facebook && array.Facebook.trim().length) {
                let site_item = {
                    "url": array.Facebook.trim()
                }
                sites.push(site_item);
            }
            if (array.Instagram && array.Instagram.trim().length) {
                let site_item = {
                    "url": array.Instagram.trim()
                }
                sites.push(site_item);
            }
            if (array.Twitter && array.Twitter.trim().length) {
                let site_item = {
                    "url": array.Twitter.trim()
                }
                sites.push(site_item);
            }
            if (array.Vkontakte && array.Vkontakte.trim().length) {
                let site_item = {
                    "url": array.Vkontakte.trim()
                }
                sites.push(site_item);
            }

            if (array.Odnoklassniki && array.Odnoklassniki.trim().length) {
                let site_item = {
                    "url": array.Odnoklassniki.trim()
                }
                sites.push(site_item);
            }

            if (array.YouTube && array.YouTube.trim().length) {
                let site_item = {
                    "url": array.YouTube.trim()
                }
                sites.push(site_item);
            }

            let telephones = [];
            if (!this.isEmpty(array.phone_1)) {
                let phone = array.phone_1.toString().split(",");
                phone = phone.map(elem => {
                    if (elem && elem.trim().length) {
                        let data = {
                            number: elem.replace(/[^0-9-()+]/g, "").trim()
                        }
                        return data;
                    }

                }).filter(f => f.number.length > 0)
                telephones = telephones.concat(phone);
            }
            if (!this.isEmpty(array.phone_2)) {
                let phone = array.phone_2.toString().split(",");
                phone = phone.map(elem => {
                    if (elem && elem.trim().length) {
                        let data = {
                            number: elem.replace(/[^0-9-()+]/g, "").trim()
                        }
                        return data;
                    }
                }).filter(f => f.number.length > 0)
                telephones = telephones.concat(phone);
            }

            let data = {
                name: array.name + (array.description ? ", " + array.description : ""),
                published: 1,
                categories: array.category,
                addresses: address,
                sites: sites,
                telephones: telephones,
            }

            let url = this.$config.api_management + this.$city.index + "/Organisation";
            this.$http.post(url, data).then((response) => {
                let res = {
                    name: response.data.name,
                    status: true
                }

                this.success_array.push(res);
            }).catch((error) => {
                let res = {
                    name: data.name
                }
                this.error_array.push(res);
                console.log(error);
            })
        },
        isEmpty(data) {
            if (typeof(data) === "object") {
                if (JSON.stringify(data) === "{}" || JSON.stringify(data) === "[]") {
                    return true;
                } else if (!data) {
                    return true;
                }
                return false;
            } else if (typeof(data) === "string") {
                if (!data.trim()) {
                    return true;
                }
                return false;
            } else if (typeof(data) === "undefined") {
                return true;
            } else {
                return false;
            }
        },
        api() {
            this.preloader = false;
            let url = this.$config.api_management + this.city + "/OrganizationsCategory/all";
            this.$http.get(url).then((response) => {
                this.list = response.data.map(function(item) {
                    let data = {
                        id: item.id,
                        yandex: item.yandex ? item.yandex.trim().toLowerCase() : null,
                        rubricator: item.rubricator ? item.rubricator.trim().toLowerCase() : null
                    }

                    if (data.yandex || data.rubricator) {
                        return data;

                    }
                }).filter(notUndefined => notUndefined !== undefined);
                console.log(this.list);
            }).finally(() => {
                this.preloader = true;
            });
        },
        unique(arr) {
            let result = [];

            for (let str of arr) {
                if (!result.includes(str)) {
                    result.push(str);
                }
            }

            return result;
        },

        saveResult(array) {
            let fileName = Date.now() + ".txt";

            let file = array.map(item => {
                return item.name
            }).sort((a, b) => {
                if (a < b) { return -1; }
                if (a > b) { return 1; }
                return 0;
            }).join("\n");

            let dataFile = new Blob([file], {
                type: "text/plain",
                name: fileName
            });
            saveAs(dataFile, fileName);
        },
    }
}
</script>
<style scoped>
.parser_info_container {
    display: flex;
    align-items: stretch;
    justify-content: flex-start;
    flex-wrap: wrap;
    margin-bottom: 20px;
    gap: 15px;
}

.parser_info_box {
    background: #fff;
    padding: 15px 15px 0;
    border-radius: 12px;
    flex: 1 1 24%;
}

.parser_info_box span[data-title] {
    font-size: 14px;
    text-transform: uppercase;
    color: #2c3e50;
    border-bottom: 1px dashed rgba(0, 0, 0, 0.2);
    padding-bottom: 10px;
    display: block;
}

.parser_info_box span {
    font-size: 48px;
    font-weight: bold;
    display: block;
}

.btn_download {
    font-size: 12px;
    color: #999;
    text-transform: uppercase;
    display: inline-block;
    transition: .2s;
}

.btn_download:hover {
    color: rgba(var(--main-color), 1.0);
    transition: .2s;
}

.btn_primary {
    margin-top: 25px;
}
</style>